import { BaseContainerModel } from '../base-container.model';
import { bl_wms_picking_sequence_RowInterface, bl_wms_picking_sequence_RowClass } from '../../dbschema/index';
    
export class WmsPickingSequenceContainer extends BaseContainerModel {
    bl_wms_picking_sequence: bl_wms_picking_sequence_RowInterface = new bl_wms_picking_sequence_RowClass();
}
